import type { LocalizedDict } from '../index'

// Admin → Shipping → International Settings (customs defaults + tax identifiers).

export type InternationalSettingsStrings = {
  loading: string
  title: string
  description: string
  customsTitle: string
  defaultContentType: string
  nonDeliveryOption: string
  customsDeclarations: string
  signCustomsAs: string
  contentTypes: {
    merchandise: string
    documents: string
    gift: string
    returned_goods: string
    sample: string
    other: string
  }
  nonDelivery: { return_to_sender: string; treat_as_abandoned: string }
  declarations: { from_order_items: string; manual: string }
  dutiesTitle: string
  prepaidDuties: string
  prepaidDutiesHint: string
  saving: string
  saveChanges: string
  taxTitle: string
  colType: string
  colAuthority: string
  colNumber: string
  colNickname: string
  delete: string
  authorityPlaceholder: string
  numberPlaceholder: string
  nicknamePlaceholder: string
  save: string
  addAnother: string
}

export const internationalSettingsI18n: LocalizedDict<InternationalSettingsStrings> = {
  en: {
    loading: 'Loading…',
    title: 'International Settings',
    description:
      'Default customs information applied to every international order. You can always change these on individual orders.',
    customsTitle: 'Default Customs Information',
    defaultContentType: 'Default Content Type',
    nonDeliveryOption: 'Non-Delivery Option',
    customsDeclarations: 'Customs Declarations',
    signCustomsAs: 'Sign Customs As',
    contentTypes: {
      merchandise: 'Merchandise',
      documents: 'Documents',
      gift: 'Gift',
      returned_goods: 'Returned Goods',
      sample: 'Sample',
      other: 'Other',
    },
    nonDelivery: { return_to_sender: 'Return to sender', treat_as_abandoned: 'Treat as abandoned' },
    declarations: {
      from_order_items: 'Create declarations from order items',
      manual: 'Enter declarations manually',
    },
    dutiesTitle: 'Duties & Taxes',
    prepaidDuties: 'Turn Guaranteed Prepaid Duties and Taxes on for all international orders',
    prepaidDutiesHint:
      'Pay a guaranteed amount for duties, taxes, and fees at the time of label purchase.',
    saving: 'Saving…',
    saveChanges: 'Save Changes',
    taxTitle: 'Tax Identifiers',
    colType: 'Type',
    colAuthority: 'Issuing Authority',
    colNumber: 'Number',
    colNickname: 'Nickname',
    delete: 'Delete',
    authorityPlaceholder: 'Issuing authority',
    numberPlaceholder: 'Number',
    nicknamePlaceholder: 'Nickname',
    save: 'Save',
    addAnother: 'Add Another Tax Identifier',
  },
  tr: {
    loading: 'Yükleniyor…',
    title: 'Yurt Dışı Ayarları',
    description:
      'Her yurt dışı siparişe uygulanan varsayılan gümrük bilgileri. Bunları her siparişte ayrıca değiştirebilirsin.',
    customsTitle: 'Varsayılan Gümrük Bilgileri',
    defaultContentType: 'Varsayılan içerik türü',
    nonDeliveryOption: 'Teslim edilemezse',
    customsDeclarations: 'Gümrük beyanları',
    signCustomsAs: 'Gümrük beyanını imzalayan',
    contentTypes: {
      merchandise: 'Ticari ürün',
      documents: 'Belge',
      gift: 'Hediye',
      returned_goods: 'İade edilen ürün',
      sample: 'Numune',
      other: 'Diğer',
    },
    nonDelivery: { return_to_sender: 'Göndericiye iade et', treat_as_abandoned: 'Terk edilmiş say' },
    declarations: {
      from_order_items: 'Beyanları sipariş ürünlerinden oluştur',
      manual: 'Beyanları elle gir',
    },
    dutiesTitle: 'Gümrük Vergileri ve Harçlar',
    prepaidDuties: 'Tüm yurt dışı siparişlerde garantili ön ödemeli gümrük vergisini aç',
    prepaidDutiesHint:
      'Gümrük vergisi, harç ve ücretler için garantili tutarı etiket alırken öde.',
    saving: 'Kaydediliyor…',
    saveChanges: 'Değişiklikleri kaydet',
    taxTitle: 'Vergi Numaraları',
    colType: 'Tür',
    colAuthority: 'Veren kurum',
    colNumber: 'Numara',
    colNickname: 'Takma ad',
    delete: 'Sil',
    authorityPlaceholder: 'Veren kurum',
    numberPlaceholder: 'Numara',
    nicknamePlaceholder: 'Takma ad',
    save: 'Kaydet',
    addAnother: 'Başka vergi numarası ekle',
  },
}
